.category-recommendations {
  display: block;
  padding: 0 16px;
}